import script from "./Prp.vue?vue&type=script&setup=true&lang=js"
export * from "./Prp.vue?vue&type=script&setup=true&lang=js"

import "./Prp.vue?vue&type=style&index=0&id=47177621&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47177621"]])

export default __exports__